import { type DietaryRestriction } from '@sg/graphql-schema';

import { type DietaryPreferencesTypes } from '../setup';

// ─────────────────────────────────────────────────────────────────────────────

export function sortPreferencesByName(preferences: DietaryPreferencesTypes) {
  const preferencesNames = Object.keys(preferences);
  const sortedPreferences = [...preferencesNames].sort(compareAlphabetically);

  return sortedPreferences as DietaryRestriction[];
}

// ─────────────────────────────────────────────────────────────────────────────

function compareAlphabetically(preference: string, nextPreference: string) {
  return preference.localeCompare(nextPreference);
}
